import React, { Component } from 'react';
const Entities = require('html-entities').XmlEntities;
const entities = new Entities();

class Blog extends Component {
  render() {

    if(this.props.data){
     console.log(this.props.data.posts)
      var posts= this.props.data.posts.map(function(post){

        return  <li>
            <blockquote>
               
               <a target="blank" href={post.URL}>{entities.decode(post.title)}</a>
               <cite>{post.date}</cite>
            </blockquote>
         </li>

      })
    }

    return (
      
    <section id="blog">
      <div className="text-container">
         <div className="row">

            <div className="two columns flex-container">
             
               
            </div>

            <div className="ten columns flex-container">
            <h1>Recent Blog Posts</h1>
                  <ul className="slides">
                        {posts}
                  </ul>
               </div>
            </div>
         </div>
   </section>  

    );
  }
}

export default Blog;
